import context, { IAppUserContext, AsyncComponentLoading, AsyncComponentError } from '@truckdown/components-systems';
import { IInitializer, IUserContext } from "@truckdown/systems";
import { defineAsyncComponent } from 'vue';

class DeveloperComponentInitializer implements IInitializer {
    name: string = 'DeveloperComponentInitializer';
    order: number = 0;

    async initialize(context: IUserContext): Promise<void> {
        let app = (context as IAppUserContext).app;
    }
}

context.registerService({
    name: 'IInitializer',
    activator: async () => {
        return new DeveloperComponentInitializer();
    }
});